import styled from 'styled-components';

export const H1 = styled.h1`
    color: var(--gray-10);
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    margin-bottom: 0;
`;

export const H2 = styled.h2`
    color: var(--gray-10);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 0;
`;

export const H3 = styled.h3`
    color: var(--gray-10);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    margin-bottom: 0;
`;

export const SecondaryText = styled.p`
    color: var(--gray-8);
    font-size: 12px;
    line-height: 20px;
    font-style: normal;
    margin: 0;
`;
